<template>
  <div
    :class="`project-card ${type === 'multiprojects'?'multi-project':''}`"
    :style="`
      width: ${width? width: '100%'};
      ${height? `height: ${height}`: '100%'};
    `"
    @click="$emit('clickAll')"
    >
    <div :style="`height: ${content_height? content_height: '100%'}`">
      <v-img
        v-if="image"
        :src="image"
        :height="content_height"
        style="position: relative; border-radius: 10px"
        class="cursor-pointer"
        >
        <div class="project-card-header project-card-image-header">
          {{header}}
        </div>
      </v-img>
      <div v-else
        >
        <div class="project-card-content-header project-card-header">
          {{header}}
        </div>
        <div :style="`height: ${content_height? `calc(${content_height} - 50px)`: '100% - 50px'}`" class="project-card-content">
          <slot name="content"/>
        </div>
      </div>
    </div>
    <div v-if="project_information" class="project-card-info-row">
      <TTooltip v-for="(info, index) in info_array"  :key="index" :value="info.tooltip">
          <div class="project-card-information">
              <TIcon :name="info.icon" small />
              <TText small class="ml-1" :text="info.value || 0" />
          </div>
      </TTooltip>
      <!-- <v-tooltip
        v-for="(info, index) in info_array"  :key="index"
        top
        >
        <template v-slot:activator="{ on }">
          <v-col v-on="on" cols="2">
            <v-row>
              <TIcon :name="info.icon" small />
              <TText small class="ml-1" :text="info.value" />
            </v-row>
          </v-col>
        </template>
        <span>{{info.tooltip}}</span>
      </v-tooltip> -->
    </div>
    <slot name="body"/>
    <div class="project-card-buttons">
      <slot name="buttons"/>
    </div>

    <RadialCheckbox
      v-if="checkbox"
      foreground_color="white"
      shadow="black"
      style="position: absolute; top: 5px; right: 5px"
      @click.native.prevent.stop="$emit('clickCheckbox')"
      :is_checked="is_checked"
    />
      <v-progress-circular v-if="loading && type == 'multiprojects'" :size="80" width="5"  indeterminate class="loading-circle-multiproject white--text"/>
      <v-progress-circular v-if="loading && type !== 'multiprojects'" :size="100" width="6"  indeterminate class="loading-circle white--text"/>
  </div>
</template>
<script>
import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
// import StandardCard from '@/components/StandardComponents/StandardCard.component.vue'
export default {
  props: [
    'header',
    'project',
    'height',
    'width',
    'hasImage',
    'is_checked',
    'checkbox',
    'image',
    'project_information',
    'info_row',
    'content_height',
    'loading',
    'type',
  ],
  components: {
    RadialCheckbox,
    TText,
    TIcon,
    // StandardCard
  },
  data: () => ({
    checked: [],
  }),
  methods: {
    test(){

    }
  },
  computed: {
    info_array: function() {
      let array = [
        {icon: 'persons-two', value: this.project_information.user_count, tooltip: this.$i18n.t('ProjectOverView.ProjectDetails.Members')},
        {icon: 'takt-plan-train', value: this.project_information.trains_count, tooltip: this.$i18n.t('ProjectOverView.ProjectDetails.Trains')},
        {icon: 'area-empty', value: this.project_information.taktareas_count, tooltip: this.$i18n.t('ProjectOverView.ProjectDetails.Taktareas')},
        {icon: 'takt-plan-waggon', value: this.project_information.waggons_count, tooltip: this.$i18n.t('ProjectOverView.ProjectDetails.Waggons')},
        {icon: 'takt-plan-workpackage', value: this.project_information.work_packages_count, tooltip: this.$i18n.t('ProjectOverView.ProjectDetails.Workpackages')},
        {icon: 'simulation-03-bottom-connector', value: this.project_information.site_count, tooltip: 'Sites' },
        {icon: 'column-rounded', value: this.project_information.element_count, tooltip: 'Elements' },
      ]
      return array
    }
  }
}

</script>
<style scoped>
  .project-card {
    background-color: var(--v-color-6-base);
    border-radius: 10px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .multi-project {
    border-width: 2px;
    border-style: solid;
    border-color: var(--primary-base);
    padding: 3px;
    padding-top: 0px;
  }
  .project-card-header {
    text-align:center;
    padding: 3px;
  }
  .project-card-content {
    overflow: hidden;
  }
  .project-card-body {

  }
  .project-card-header {
    padding: 10px;
    height: 100%;
    width: 100%;
    text-shadow: 0px 1px #000;
    font-size: 20px;
    text-align: left;
  }
  .project-card-image-header {
    color: rgba(255,255,255, 0.9);
    background: linear-gradient(to top,rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.8))
  }
  .project-card-content {
    height: 200px;
  }
  .project-card-content-header {

  }
  .project-card-info-row {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
  }
  .project-card-buttons {
    display: flex;
    grid-gap: 10px;
    flex-wrap: wrap;
    /* padding-left: 5px; */
  }
  .project-card-buttons > .v-btn {
    letter-spacing: normal !important;
    text-indent: 0 !important;
    text-transform: none !important;
    color: var(--v-primary-base);
    background-color: rgba(0, 0, 0, 0) !important;
    border: 1px solid;
    min-width: 80px;
  }
  .loading-circle-multiproject {
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
  }

  .loading-circle {
    position: absolute;
    left: 50%;
    top: 35%;
    transform: translate(-50%, -50%);
  }
  .project-card-information {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
  }
</style>
